import L from 'leaflet'
import {MapContainer,TileLayer,GeoJSON, CircleMarker,useMap} from'react-leaflet'


export const Legend = ({Program,districts,facilities}) => {
    const elementExists = document.getElementById("legend_id_choro");
    if (elementExists){
        elementExists.remove()
    }
    const map = useMap();
    
    var legend = L.control({ position: 'topright' })
    
    legend.onAdd = function () {
        var div = L.DomUtil.create('div', 'legend_choropleth')
        div.setAttribute('id',`legend_id_choro`)

        //create a legend title box
        var legend_title = document.createElement('div')
        legend_title.setAttribute('id','choropleth_legend_title')
        legend_title.innerText = `${Program} Implementation`
        div.appendChild(legend_title)

        // Create container for legend items
        var legend_items = document.createElement('div')
        legend_items.setAttribute('class', 'legend-items')
        
        // District legend item
        var district_item = document.createElement('div')
        district_item.setAttribute('class', 'legend-item')
        
        var district_color = document.createElement('div')
        district_color.setAttribute('class', 'legend-color')
        district_color.style.backgroundColor = '#FF9149'
        district_color.style.width = '20px'
        district_color.style.height = '20px'
        district_color.style.display = 'inline-block'
        
        var district_label = document.createElement('span')
        district_label.innerText = `Implementing Districts ${districts}`
        district_label.style.marginLeft = '10px'
        
        district_item.appendChild(district_color)
        district_item.appendChild(district_label)

        // Non-implementing District legend item
        var non_district_item = document.createElement('div')
        non_district_item.setAttribute('class', 'legend-item')
        non_district_item.style.marginTop = '5px'
        
        var non_district_color = document.createElement('div')
        non_district_color.setAttribute('class', 'legend-color')
        non_district_color.style.backgroundColor = 'gray'  // Light gray color
        non_district_color.style.width = '20px'
        non_district_color.style.height = '20px'
        non_district_color.style.display = 'inline-block'
        
        var non_district_label = document.createElement('span')
        non_district_label.innerText = 'Non-implementing Districts'
        non_district_label.style.marginLeft = '10px'
        
        non_district_item.appendChild(non_district_color)
        non_district_item.appendChild(non_district_label)
        
        // Facility legend item
        var facility_item = document.createElement('div')
        facility_item.setAttribute('class', 'legend-item')
        facility_item.style.marginTop = '5px'
        
        var facility_marker = document.createElement('div')
        facility_marker.setAttribute('class', 'legend-marker')
        facility_marker.style.backgroundColor = 'red'
        facility_marker.style.width = '20px'
        facility_marker.style.height = '20px'
        facility_marker.style.borderRadius = '50%'
        facility_marker.style.display = 'inline-block'
        
        var facility_label = document.createElement('span')
        facility_label.innerText = `Implementing Facilities ${facilities}`
        facility_label.style.marginLeft = '10px'
        
        facility_item.appendChild(facility_marker)
        facility_item.appendChild(facility_label)
        
        // Add items to container
        legend_items.appendChild(facility_item)
        legend_items.appendChild(district_item)
        legend_items.appendChild(non_district_item)
        
        div.appendChild(legend_items)

        return div
    }
    map.addControl(legend)
    
    return null
}